import { type CharityVettingStatusType } from 'api/users/types';
import usersAPISlice from 'api/users/usersAPISlice';

type UseCharityVettingStatusResult = {
  isLoading: boolean;
  hasNoCharity: boolean;
  charityVettingStatus: CharityVettingStatusType | undefined;
};

const isUnauthorizedError = (error: unknown): boolean =>
  !!error && typeof error === 'object' && 'status' in error && error.status === 401;

const useCharityVettingStatus = (): UseCharityVettingStatusResult => {
  const { data: currentUser, isLoading, error } = usersAPISlice.endpoints.getCurrentUser.useQuery();

  if (isLoading) {
    return { isLoading, hasNoCharity: false, charityVettingStatus: undefined };
  }

  if (isUnauthorizedError(error)) {
    return { isLoading, hasNoCharity: true, charityVettingStatus: undefined };
  }

  return {
    isLoading,
    hasNoCharity: false,
    charityVettingStatus: currentUser?.charityVettingStatus,
  };
};

export default useCharityVettingStatus;
